import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, link }) =>
    present(
      repository
        .removeProjectExternalLink(project, link)
        .then(() => ({ project, link }))
        .catch(() =>
          Promise.reject({
            project,
            link,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
